import { NotFoundPage } from '@scoring/ui';
import { Route } from 'react-router';
import { lazyPage } from '../../shell/lazyPage';

const HeadJudgeLayout = lazyPage(() => import('./HeadJudgeLayout.tsx'), 'HeadJudgeLayout');
const HeadJudgeEntryPage = lazyPage(() => import('./HeadJudgeEntryPage.tsx'), 'HeadJudgeEntryPage');
const HeadJudgeScoreManagerPage = lazyPage(
    () => import('./HeadJudgeScoreManagerPage.tsx'),
    'HeadJudgeScoreManagerPage'
);

export const headJudgeRoutes = (
    <Route path="head-judge" lazy={HeadJudgeLayout}>
        <Route index lazy={HeadJudgeEntryPage} />
        <Route
            path=":externalId/:competitionExternalId?/:categoryExternalId?/:phaseExternalId?/:heatExternalId?"
            lazy={HeadJudgeScoreManagerPage}
        />
        <Route path="*" element={<NotFoundPage />} />
    </Route>
);
